


























































































































import { Vue, Component, Ref } from 'vue-property-decorator'
import type { ProdutoDaImportacao } from '@/models/ImportacaoDeNota'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FindAtributoUseCase } from '@/usecases'
import { atributoDaVariante, criarVariantesDoProduto } from '@/usecases/importacao-de-notas/importacaoHelpers'
import SeletorDeMarca from '@/components/produto/SeletorDeMarca.vue'
import SeletorDeGenero from '@/components/produto/SeletorDeGenero.vue'
import SeletorDeEstacao from '@/components/produto/SeletorDeEstacao.vue'
import SeletorDeCategoria from '../../../produtos/EdicaoDeProduto/SeletorDeCategoria.vue'
import SeletorDeTag from '@/components/produto/SeletorDeTag.vue'
import SeletorDeUnidadeDeMedida from '@/components/produto/SeletorDeUnidadeDeMedida.vue'
import CampoDecimal from '@/components/ui/CampoDecimal.vue'
import DialogoDeSelecaoDeGradeDeProdutos from '@/components/produto/DialogoDeSelecaoDeGradeDeProdutos.vue'
import DeParaVariantesDaNota from './DeParaVariantesDaNota.vue'

/**
 * Diálogo dedicado de criação de produto na importação (item sem match no catálogo).
 * Prefilla do item da nota, monta grade/variantes e emite o produto criado.
 */
@Component({
	components: {
		SeletorDeMarca, SeletorDeGenero, SeletorDeEstacao, SeletorDeCategoria,
		SeletorDeTag, SeletorDeUnidadeDeMedida, CampoDecimal, DialogoDeSelecaoDeGradeDeProdutos,
		DeParaVariantesDaNota,
	},
})
export default class DialogoDeCriarProduto extends Vue {
	@Ref() readonly dialogoDeGrade!: { mostrar: () => void }

	dialog = false
	salvando = false
	gerandoVariantes = false
	variantesDoXml = false
	qComReferencia = 0
	indice = -1
	produto: any = null
	itensDaNota: any[] = []
	editando = false

	private findAtributos = new FindAtributoUseCase()

	get temVariantes(): boolean {
		return !!(this.produto && this.produto.variantes && this.produto.variantes.length)
	}

	/** Item veio de um agrupamento (nota aberta) — tem mais de uma linha por trás. */
	get ehAgrupado(): boolean {
		return (this.itensDaNota || []).length > 1
	}

	get totalQuantidade(): number {
		if (!this.produto || !this.produto.variantes) return 0
		return this.produto.variantes.reduce((s: number, v: any) => s + (Number(v.quantidadeImportacao) || 0), 0)
	}

	get totalDaReferencia(): number {
		return this.qComReferencia
	}

	get saldoQuantidade(): number {
		return this.totalDaReferencia - this.totalQuantidade
	}

	get variantesIncompletas(): number {
		if (!this.produto || !this.produto.variantes) return 0
		return this.produto.variantes.filter((v: any) => this.incompleta(v)).length
	}

	incompleta(v: any): boolean {
		return !this.valorAtributo(v, 'Tamanho') || !this.valorAtributo(v, 'Cor')
	}

	get podeSalvar(): boolean {
		if (!this.produto) return false
		if (!this.produto.nome || !this.produto.sku) return false
		if (this.produto.tipo === 'Com Variantes' && !this.temVariantes) return false
		if (this.variantesIncompletas > 0) return false
		return true
	}

	mostrar(item: ProdutoDaImportacao, indice: number, padrao: any = {}, produtoExistente: any = null) {
		this.indice = indice
		this.editando = !!produtoExistente
		this.itensDaNota = (item.produtosAgrupados && (item.produtosAgrupados as any).length)
			? (item.produtosAgrupados as any)
			: [item]
		this.qComReferencia = Number(String(item.nota.qCom).replace(',', '.')) || 0
		const precoCompra = Number(String(item.nota.vUnCom).replace(',', '.')) || 0
		// Preço de venda sugerido pela margem/markup da etapa de Conferência.
		const precoVenda = padrao.precoVenda != null ? Number(padrao.precoVenda) : precoCompra
		this.produto = {
			id: '',
			nome: item.nota.xProd,
			sku: item.nota.cProd,
			skuPai: item.nota.cProd,
			unidadeDeMedida: item.nota.uCom || 'UNID',
			precoCompra: precoCompra,
			preco: precoVenda,
			ncm: { id: '', codigo: item.nota.NCM, descricao: '' },
			tipo: 'Com Variantes',
			// atributos replicados da criação anterior (Fase 3)
			marca: padrao.marca || null,
			genero: padrao.genero || null,
			categoria: padrao.categoria || null,
			estacao: padrao.estacao || null,
			tags: padrao.tags ? [...padrao.tags] : [],
			variantes: [], eans: [], urlImagens: [],
			atributosProduto: [],
		}

		// Modo edição: recarrega o produto já montado (com a grade/variantes) para ajustar,
		// mantendo itensDaNota e qComReferencia derivados do item da nota.
		if (produtoExistente) {
			this.produto = JSON.parse(JSON.stringify(produtoExistente))
		}

		// Grade sempre manual/obrigatória: o produto nasce de uma grade real e completa
		// (evita grade quebrada). O XML entra depois via de-para (EAN + quantidade).
		this.variantesDoXml = false

		this.dialog = true
	}

	/** Índices de itens da NF já vinculados a alguma variante. */
	get indicesUsados(): Set<number> {
		const usados = new Set<number>()
		if (this.produto && this.produto.variantes) {
			this.produto.variantes.forEach((v: any) => {
				if (v.itemDaNotaIdx != null) usados.add(v.itemDaNotaIdx)
			})
		}
		return usados
	}

	get opcoesItensDaNota() {
		return this.itensDaNota
			.map((linha: any, idx: number) => {
				const qtd = Number(linha.nota.qCom) || 0
				const ean = linha.nota.cEAN && linha.nota.cEAN !== 'SEM GTIN' ? ` · ${linha.nota.cEAN}` : ''
				return { text: `${linha.nota.xProd} · qtd ${qtd}${ean}`, value: idx }
			})
			.filter((o: any) => !this.indicesUsados.has(o.value))
	}

	eanDaVariante(v: any): string {
		return v && v.eans && v.eans[0] ? v.eans[0] : ''
	}

	setEan(v: any, valor: string) {
		v.eans = valor ? [valor] : []
	}

	/** De-para: vincula a variante a um item da NF, trazendo EAN e quantidade daquela linha. */
	aplicarItemDaNota(v: any, idx: number) {
		const linha = this.itensDaNota[idx]
		if (linha == null) return
		const ean = linha.nota.cEAN && linha.nota.cEAN !== 'SEM GTIN' ? linha.nota.cEAN : null
		if (ean) v.eans = [ean]
		v.quantidadeImportacao = Number(linha.nota.qCom) || 0
		// marca o item da NF como usado (some do dropdown das outras variantes)
		this.$set(v, 'itemDaNotaIdx', idx)
		this.$forceUpdate()
	}

	atributo(v: any, nome: string): string {
		return atributoDaVariante(v, nome)
	}

	/** Valor do atributo para edição: vazio (não "—") quando ausente, pra o usuário digitar. */
	valorAtributo(v: any, nome: string): string {
		const val = atributoDaVariante(v, nome)
		return val === '—' ? '' : val
	}

	setAtributo(v: any, nome: string, valor: string) {
		if (!v.atributosVariante) v.atributosVariante = []
		const a = v.atributosVariante.find((x: any) => String(x.nome).toUpperCase() === nome.toUpperCase())
		if (a) a.valor = valor
		else v.atributosVariante.push({ id: '', nome, valor })
	}

	removerVariante(i: number) {
		this.produto.variantes.splice(i, 1)
	}

	montarGrade() {
		this.dialogoDeGrade.mostrar()
	}

	async onGradeConfirmada(cores: string[], tamanhos: string[]) {
		try {
			this.gerandoVariantes = true
			const atributos = await this.findAtributos.findAll()
			let atributoCor = (atributos || []).find((a: any) => a.nome.toUpperCase() === 'COR')
			let atributoTamanho = (atributos || []).find((a: any) => a.nome.toUpperCase() === 'TAMANHO')
			if (!atributoCor) atributoCor = await this.findAtributos.create({ id: '', nome: 'Cor' } as any)
			if (!atributoTamanho) atributoTamanho = await this.findAtributos.create({ id: '', nome: 'Tamanho' } as any)

			this.produto.atributosProduto = [
				{ id: '', atributo: atributoCor, valores: cores, descontoVarejo: 0 },
				{ id: '', atributo: atributoTamanho, valores: tamanhos, descontoVarejo: 0 },
			]
			this.produto.variantes = criarVariantesDoProduto(this.produto, this.produto.atributosProduto, Date.now())
			this.variantesDoXml = false
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.gerandoVariantes = false
		}
	}

	salvar() {
		if (!this.podeSalvar) return
		this.salvando = true
		this.produto.tipo = 'Com Variantes'
		this.$emit('criado', JSON.parse(JSON.stringify(this.produto)), this.indice)
		this.salvando = false
		this.fechar()
	}

	fechar() {
		this.dialog = false
		this.produto = null
		this.indice = -1
		this.variantesDoXml = false
	}
}
